import type { IPaletteItem } from '@repo/web-chrome/components/command-palette/palette-item-types';
import { getCefrContent } from '@/content/cefr';
import { getCompareContent } from '@/content/compare';
import { getNativeContent } from '@/content/native';
import { cefrPagesRegistry } from './pages-registry-from-cefr';
import { comparePagesRegistry } from './pages-registry-from-compare';
import { nativePagesRegistry } from './pages-registry-from-native';

export async function loadLocalizedPalettePages(locale: string): Promise<IPaletteItem[]> {
  const [cefr, native, compare] = await Promise.all([
    getCefrContent(locale),
    getNativeContent(locale),
    getCompareContent(locale),
  ]);
  return [
    ...cefrPagesRegistry(cefr),
    ...nativePagesRegistry(native),
    ...comparePagesRegistry(compare),
  ];
}
